export default __webpack_public_path__ + "static/media/min-investment.4c56d5ca.svg";